import { render, staticRenderFns } from "./ForecastingDataSetup.vue?vue&type=template&id=5cf988c9"
import script from "./ForecastingDataSetup.vue?vue&type=script&lang=js"
export * from "./ForecastingDataSetup.vue?vue&type=script&lang=js"
import style0 from "./ForecastingDataSetup.vue?vue&type=style&index=0&id=5cf988c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports